import * as React from 'react';
import { Message } from '@alifd/next';
import { useAppSelector } from '../../redux/hooks';

export default function otherInfo(props: any) {
  const { price = {}, type, i18n } = props;
  const { batchNum = 1, saleType, unitEven = '' } = price;
  const skuInfo = useAppSelector(state => state.sku[type]);
  const { isSoldOut } = skuInfo;

  return (<div className='other-info'>
    {isSoldOut &&
      <Message title={`${i18n["marketAction.soldoutTip1"]} ${i18n["marketAction.soldoutTip2"]}`} type="warning" />}
    {saleType && batchNum > 1 && <div className='sele-type'>1 {saleType} = {batchNum} {unitEven}</div>}
  </div>
  )
}
